export default __webpack_public_path__ + "assets/images/d5d341054ee7d4d0d3299d52ee214fd2.jpg";